/**
 * @generated SignedSource<<f63236f61a7a5bb893345c99fe232288>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityContentType = "ALL" | "COMMENT" | "POST" | "%future added value";
export type uUserActivityFragmentQuery$variables = {
  club: string;
  contentType: ActivityContentType;
  cursor?: string | null | undefined;
  first?: number | null | undefined;
  id: string;
};
export type uUserActivityFragmentQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"uUserActivityFragment">;
  } | null | undefined;
};
export type uUserActivityFragmentQuery = {
  response: uUserActivityFragmentQuery$data;
  variables: uUserActivityFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "Variable",
  "name": "club",
  "variableName": "club"
},
v3 = {
  "kind": "Variable",
  "name": "contentType",
  "variableName": "contentType"
},
v4 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vote",
    "storageKey": null
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarFallback",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v17 = [
  (v16/*: any*/),
  (v6/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageFile",
  "kind": "LinkedField",
  "name": "photo",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votes",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawID",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playback",
  "storageKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "uUserActivityFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v4/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "uUserActivityFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uUserActivityFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "UserActivityConnection",
                "kind": "LinkedField",
                "name": "activities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserActivityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "space",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v9/*: any*/),
                                  (v6/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "scheduledPublishDate",
                                "storageKey": null
                              },
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PostVote",
                                "kind": "LinkedField",
                                "name": "userVote",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "commentCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "username",
                                    "storageKey": null
                                  },
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": [
                                      (v2/*: any*/)
                                    ],
                                    "concreteType": "Badge",
                                    "kind": "LinkedField",
                                    "name": "badges",
                                    "plural": true,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "text",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "textColor",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bgColor",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v18/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Club",
                                "kind": "LinkedField",
                                "name": "club",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SpaceGroup",
                                    "kind": "LinkedField",
                                    "name": "groups",
                                    "plural": true,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "spaces",
                                        "plural": true,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          (v10/*: any*/),
                                          (v11/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pinned",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pinnedUniversal",
                                "storageKey": null
                              },
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "coverContent",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v12/*: any*/)
                                    ],
                                    "type": "ExternalVideoCover",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v6/*: any*/),
                                      (v21/*: any*/),
                                      (v10/*: any*/),
                                      (v16/*: any*/)
                                    ],
                                    "type": "ImageFile",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v6/*: any*/),
                                      (v21/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "muxId",
                                        "storageKey": null
                                      },
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "status",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ImageFile",
                                        "kind": "LinkedField",
                                        "name": "thumbnail",
                                        "plural": false,
                                        "selections": (v17/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "VideoPlayback",
                                        "kind": "LinkedField",
                                        "name": "playback",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "VideoFileTokens",
                                            "kind": "LinkedField",
                                            "name": "tokens",
                                            "plural": false,
                                            "selections": [
                                              (v22/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "storyboard",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "thumbnail",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "VideoFile",
                                    "abstractKey": null
                                  },
                                  (v5/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Attachment",
                                "kind": "LinkedField",
                                "name": "attachments",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "originalName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "size",
                                    "storageKey": null
                                  },
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Post",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v18/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentVote",
                                "kind": "LinkedField",
                                "name": "userVote",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Post",
                                    "kind": "LinkedField",
                                    "name": "post",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "space",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v9/*: any*/),
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Comment",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "event",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "EventComment",
                                "abstractKey": null
                              }
                            ],
                            "type": "CommentInterface",
                            "abstractKey": "__isCommentInterface"
                          },
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": [
                  "club",
                  "contentType"
                ],
                "handle": "connection",
                "key": "uUser_activities",
                "kind": "LinkedHandle",
                "name": "activities"
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "47a26f6650e1737e7b5fae3a24d5cd57",
    "id": null,
    "metadata": {},
    "name": "uUserActivityFragmentQuery",
    "operationKind": "query",
    "text": "query uUserActivityFragmentQuery(\n  $club: String!\n  $contentType: ActivityContentType!\n  $cursor: String\n  $first: Int = 10\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...uUserActivityFragment_7srTM\n    id\n  }\n}\n\nfragment commentPreviewFragment on CommentInterface {\n  __isCommentInterface: __typename\n  id\n  content\n  author {\n    id\n    displayName\n    avatarFallback\n    photo {\n      signedUrl\n      id\n    }\n  }\n  votes\n  userVote {\n    vote\n  }\n  ... on Comment {\n    post {\n      title\n      slug\n      space {\n        __typename\n        slug\n        id\n      }\n      id\n    }\n  }\n  ... on EventComment {\n    event {\n      title\n      slug\n      id\n    }\n  }\n  __typename\n}\n\nfragment memberBadgeFragment on Badge {\n  text\n  textColor\n  bgColor\n}\n\nfragment postAttachmentsPreview_post on Post {\n  id\n  attachments {\n    id\n    originalName\n    size\n    signedUrl\n  }\n}\n\nfragment postBottomActionsFragment on Post {\n  id\n  slug\n  url\n  space {\n    __typename\n    slug\n    id\n  }\n  userVote {\n    vote\n  }\n  commentCount\n  author {\n    id\n  }\n  votes\n}\n\nfragment postContentPreviewFragment on Post {\n  content\n}\n\nfragment postCoverFragment on Post {\n  coverContent {\n    ... on ExternalVideoCover {\n      url\n    }\n    ... on ImageFile {\n      id\n      rawID\n      name\n      signedUrl\n    }\n    ... on VideoFile {\n      id\n      rawID\n      muxId\n      url\n      status\n      thumbnail {\n        signedUrl\n        id\n      }\n      playback {\n        playback\n        tokens {\n          playback\n          storyboard\n          thumbnail\n        }\n      }\n    }\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  id\n}\n\nfragment postHeaderFragment_4bIyVY on Post {\n  id\n  slug\n  author {\n    id\n    displayName\n    username\n    avatarFallback\n    badges(club: $club) {\n      id\n      ...memberBadgeFragment\n    }\n    photo {\n      signedUrl\n      id\n    }\n  }\n  space {\n    __typename\n    id\n    name\n    icon\n    slug\n  }\n  club {\n    id\n    slug\n  }\n  createdAt\n  pinned\n  pinnedUniversal\n  ...postMoveDialogQuery\n}\n\nfragment postMoveDialogQuery on Post {\n  id\n  space {\n    __typename\n    id\n  }\n  club {\n    slug\n    groups {\n      id\n      name\n      spaces {\n        __typename\n        id\n        name\n        icon\n      }\n    }\n    id\n  }\n}\n\nfragment postPreviewFragment_4bIyVY on Post {\n  title\n  slug\n  space {\n    __typename\n    slug\n    id\n  }\n  scheduledPublishDate\n  ...postBottomActionsFragment\n  ...postHeaderFragment_4bIyVY\n  ...postContentPreviewFragment\n  ...postCoverFragment\n  ...postAttachmentsPreview_post\n}\n\nfragment uUserActivityFragment_7srTM on User {\n  activities(first: $first, after: $cursor, club: $club, contentType: $contentType) {\n    edges {\n      node {\n        ... on Post {\n          id\n          ...postPreviewFragment_4bIyVY\n        }\n        ... on CommentInterface {\n          __isCommentInterface: __typename\n          ...commentPreviewFragment\n        }\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "b504baaddbda37672d4d2fe1e1a3b43a";

export default node;
